// extracted by mini-css-extract-plugin
export var addToCartWrapper = "_vz-8";
export var editMode = "_vz-3";
export var headerRow = "_vz-a";
export var headerTitle = "_vz-b";
export var product = "_vz-1";
export var productDetails = "_vz-5";
export var productDivider = "_vz-7";
export var productImage = "_vz-2";
export var productInfo = "_vz-4";
export var productTitle = "_vz-6";
export var strikethrough = "_vz-9";
export var upsellProductsCard = "_vz-0";